// import React, { useState, useEffect } from 'react';
// import { Card, Table, Button, Input, Breadcrumb, Row, Col, Tag, Space, message } from 'antd';
// import { ArrowLeftOutlined, HomeOutlined, SearchOutlined, CopyOutlined, FileExcelOutlined, FilePdfOutlined, CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';
// import DashboardService from '../../services/DashboardService';
// // Dynamic imports for export libraries

// const DashboardPage = ({ userdata }) => {
//   const navigate = useNavigate();
//   const [searchText, setSearchText] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [dashboardStats, setDashboardStats] = useState({
//     kanbans_in_stock: 0,
//     kanbans_sent_today: 0,
//     kanbans_received_today: 0,
//     date: ''
//   });
//   const [statsLoading, setStatsLoading] = useState(true);
//   const [tableData, setTableData] = useState([]);
//   const [tableLoading, setTableLoading] = useState(true);

//   // Load dashboard statistics on component mount
//   useEffect(() => {
//     loadDashboardStats();
//     loadActiveData();
//   }, []);

//   const loadDashboardStats = async () => {
//     try {
//       setStatsLoading(true);
//       const response = await DashboardService.getSupermarketDashboard();
      
//       if (response.status && response.data) {
//         setDashboardStats({
//           kanbans_in_stock: response.data.kanbans_in_stock || 0,
//           kanbans_sent_today: response.data.kanbans_sent_today || 0,
//           kanbans_received_today: response.data.kanbans_received_today || 0,
//           date: response.data.date || ''
//         });
//       } else {
//         message.error(response.message || 'Failed to load dashboard statistics');
//       }
//     } catch (error) {
//       message.error('Error loading dashboard statistics');
//       console.error('Error loading dashboard stats:', error);
//     } finally {
//       setStatsLoading(false);
//     }
//   };

//   const loadActiveData = async () => {
//     try {
//       setTableLoading(true);
//       const response = await DashboardService.getSupermarketActiveData();
      
//       if (response.status && response.data) {
//         // Map API data to table format
//         const mappedData = response.data.map((item, index) => ({
//           key: item.kbs_id,
//           sNo: index + 1,
//           kanbanNo: item.kanban_no,
//           poNo: 'N/A', // Not available in API response
//           color: 'N/A', // Not available in API response
//           inwardLine: item.line_no,
//           dateTime: item.inward,
//           sizeQuantity: 'N/A', // Not available in API response
//           total: 'N/A', // Not available in API response
//           // Keep additional fields for potential future use
//           status: item.status,
//           dept: item.dept,
//           outward: item.outward,
//           criticalTime: item.critical_time,
//           remarks: item.remarks,
//           rackId: item.rack_id
//         }));
        
//         setTableData(mappedData);
//       } else {
//         message.error(response.message || 'Failed to load active data');
//         setTableData([]);
//       }
//     } catch (error) {
//       message.error('Error loading active data');
//       console.error('Error loading active data:', error);
//       setTableData([]);
//     } finally {
//       setTableLoading(false);
//     }
//   };

//   const filteredData = tableData.filter(item =>
//     item.kanbanNo.toLowerCase().includes(searchText.toLowerCase()) ||
//     item.inwardLine.toLowerCase().includes(searchText.toLowerCase()) ||
//     item.poNo.toLowerCase().includes(searchText.toLowerCase()) ||
//     item.color.toLowerCase().includes(searchText.toLowerCase())
//   );

//   const handleExport = (type) => {
//     if (tableData.length === 0) {
//       message.warning('No data to export');
//       return;
//     }

//     switch (type) {
//       case 'copy':
//         handleCopyToClipboard();
//         break;
//       case 'excel':
//         handleExcelExport();
//         break;
//       case 'pdf':
//         handlePDFExport();
//         break;
//       default:
//         message.info(`Export to ${type} functionality will be implemented`);
//     }
//   };

//   const handleCopyToClipboard = () => {
//     try {
//       // Prepare data for copying
//       const headers = ['S.No', 'Kanban No', 'PO No', 'Color', 'Inward Line', 'Date & Time', 'Size & Quantity', 'Total'];
//       const csvContent = [
//         headers.join('\t'),
//         ...filteredData.map(row => [
//           row.sNo,
//           row.kanbanNo,
//           row.poNo,
//           row.color,
//           row.inwardLine,
//           row.dateTime,
//           row.sizeQuantity,
//           row.total
//         ].join('\t'))
//       ].join('\n');

//       navigator.clipboard.writeText(csvContent).then(() => {
//         message.success('Data copied to clipboard');
//       }).catch(() => {
//         // Fallback for older browsers
//         const textArea = document.createElement('textarea');
//         textArea.value = csvContent;
//         document.body.appendChild(textArea);
//         textArea.select();
//         document.execCommand('copy');
//         document.body.removeChild(textArea);
//         message.success('Data copied to clipboard');
//       });
//     } catch (error) {
//       message.error('Failed to copy data');
//       console.error('Copy error:', error);
//     }
//   };

//   const handleExcelExport = async () => {
//     try {
//       // Dynamic import for XLSX
//       const XLSX = await import('xlsx');
      
//       // Prepare data for Excel
//       const headers = ['S.No', 'Kanban No', 'PO No', 'Color', 'Inward Line', 'Date & Time', 'Size & Quantity', 'Total'];
//       const excelData = [
//         headers,
//         ...filteredData.map(row => [
//           row.sNo,
//           row.kanbanNo,
//           row.poNo,
//           row.color,
//           row.inwardLine,
//           row.dateTime,
//           row.sizeQuantity,
//           row.total
//         ])
//       ];

//       // Create workbook and worksheet
//       const ws = XLSX.utils.aoa_to_sheet(excelData);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, 'Kanbans In Stock');

//       // Generate filename with current date
//       const now = new Date();
//       const dateStr = now.toISOString().split('T')[0];
//       const filename = `Kanbans_In_Stock_${dateStr}.xlsx`;

//       // Save file
//       XLSX.writeFile(wb, filename);
//       message.success('Excel file downloaded successfully');
//     } catch (error) {
//       message.error('Failed to export Excel file');
//       console.error('Excel export error:', error);
//     }
//   };

//   const handlePDFExport = async () => {
//     try {
//       // Dynamic import for jsPDF
//       const { jsPDF } = await import('jspdf');
//       await import('jspdf-autotable');
      
//       const doc = new jsPDF('landscape');
      
//       // Add title
//       doc.setFontSize(16);
//       doc.text('Kanbans In Stock', 14, 15);
      
//       // Add date
//       doc.setFontSize(10);
//       const now = new Date();
//       const generatedDate = now.toLocaleDateString();
//       doc.text(`Generated on: ${generatedDate}`, 14, 25);

//       // Prepare table data
//       const headers = ['S.No', 'Kanban No', 'PO No', 'Color', 'Inward Line', 'Date & Time', 'Size & Quantity', 'Total'];
//       const tableData = filteredData.map(row => [
//         row.sNo,
//         row.kanbanNo,
//         row.poNo,
//         row.color,
//         row.inwardLine,
//         row.dateTime,
//         row.sizeQuantity,
//         row.total
//       ]);

//       // Add table
//       doc.autoTable({
//         head: [headers],
//         body: tableData,
//         startY: 30,
//         styles: { fontSize: 8 },
//         headStyles: { fillColor: [66, 139, 202] },
//         alternateRowStyles: { fillColor: [245, 245, 245] },
//         margin: { left: 14, right: 14 }
//       });

//       // Generate filename with current date
//       const fileDate = now.toISOString().split('T')[0];
//       const filename = `Kanbans_In_Stock_${fileDate}.pdf`;

//       // Save file
//       doc.save(filename);
//       message.success('PDF file downloaded successfully');
//     } catch (error) {
//       message.error('Failed to export PDF file');
//       console.error('PDF export error:', error);
//     }
//   };

//   const handleView = (record) => {
//     navigate(`/view-kanban/${record.kanbanNo}`);
//   };

//   const columns = [
//     {
//       title: (
//         <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//           S. No
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <CaretUpOutlined style={{ fontSize: '10px', color: '#999' }} />
//             <CaretDownOutlined style={{ fontSize: '10px', color: '#999' }} />
//           </div>
//         </div>
//       ),
//       dataIndex: 'sNo',
//       key: 'sNo',
//       width: 80,
//     },
//     {
//       title: (
//         <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//           Kanban No
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <CaretUpOutlined style={{ fontSize: '10px', color: '#999' }} />
//             <CaretDownOutlined style={{ fontSize: '10px', color: '#999' }} />
//           </div>
//         </div>
//       ),
//       dataIndex: 'kanbanNo',
//       key: 'kanbanNo',
//       width: 120,
//     },
//     {
//       title: (
//         <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//           PO No
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <CaretUpOutlined style={{ fontSize: '10px', color: '#999' }} />
//             <CaretDownOutlined style={{ fontSize: '10px', color: '#999' }} />
//           </div>
//         </div>
//       ),
//       dataIndex: 'poNo',
//       key: 'poNo',
//       width: 150,
//     },
//     {
//       title: (
//         <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//           Color
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <CaretUpOutlined style={{ fontSize: '10px', color: '#999' }} />
//             <CaretDownOutlined style={{ fontSize: '10px', color: '#999' }} />
//           </div>
//         </div>
//       ),
//       dataIndex: 'color',
//       key: 'color',
//       width: 150,
//     },
//     {
//       title: (
//         <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//           Inward Line
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <CaretUpOutlined style={{ fontSize: '10px', color: '#999' }} />
//             <CaretDownOutlined style={{ fontSize: '10px', color: '#999' }} />
//           </div>
//         </div>
//       ),
//       dataIndex: 'inwardLine',
//       key: 'inwardLine',
//       width: 120,
//       render: (text) => (
//         <Tag style={{ backgroundColor: '#333333', color: 'white', borderRadius: '12px', padding: '2px 8px' }}>
//           {text}
//         </Tag>
//       ),
//     },
//     {
//       title: (
//         <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//           Date & Time
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <CaretUpOutlined style={{ fontSize: '10px', color: '#999' }} />
//             <CaretDownOutlined style={{ fontSize: '10px', color: '#999' }} />
//           </div>
//         </div>
//       ),
//       dataIndex: 'dateTime',
//       key: 'dateTime',
//       width: 180,
//     },
//     {
//       title: (
//         <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//           Size & Quantity
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <CaretUpOutlined style={{ fontSize: '10px', color: '#999' }} />
//             <CaretDownOutlined style={{ fontSize: '10px', color: '#999' }} />
//           </div>
//         </div>
//       ),
//       dataIndex: 'sizeQuantity',
//       key: 'sizeQuantity',
//       width: 200,
//       render: (text, record) => (
//         <Space direction="vertical" size="small">
//           <Tag style={{ backgroundColor: '#52c41a', color: 'white', borderRadius: '12px', padding: '2px 8px' }}>
//             {text}
//           </Tag>
//           <Tag style={{ backgroundColor: '#ff4d4f', color: 'white', borderRadius: '12px', padding: '2px 8px' }}>
//             {record.total}
//           </Tag>
//         </Space>
//       ),
//     },
//     {
//       title: 'Action',
//       key: 'action',
//       width: 100,
//       render: (text, record) => (
//         <Button type="primary" size="small" onClick={() => handleView(record)} style={{ backgroundColor: '#1890ff', border: 'none', borderRadius: '4px' }}>
//           View
//         </Button>
//       ),
//     },
//   ];

//   return (
//     <div style={{ padding: '0', backgroundColor: '#f5f5f5', minHeight: '100vh', margin: 0 }}>
//       {/* Header Bar */}
//       {/* <div style={{ height: '50px', backgroundColor: '#333333', display: 'flex', alignItems: 'center', padding: '0 16px', color: 'white' }}>
//         <ArrowLeftOutlined style={{ fontSize: '18px', marginRight: '12px', color: 'white' }} />
//         <span style={{ fontSize: '16px', fontWeight: '500', color: 'white' }}>Home - Dashboard</span>
//       </div> */}

//       {/* Navigation Bar */}
//       {/* <div style={{ height: '40px', backgroundColor: '#e8e8e8', display: 'flex', alignItems: 'center', padding: '0 16px', borderBottom: '1px solid #d9d9d9' }}>
//         <Breadcrumb>
//           <Breadcrumb.Item>
//             <HomeOutlined style={{ marginRight: '4px' }} />
//             Home
//           </Breadcrumb.Item>
//           <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
//         </Breadcrumb>
//       </div> */}

//       {/* Main Content */}
//       <div style={{ padding: '24px', minHeight: 'calc(100vh - 90px)' }}>
//         {/* Summary Cards */}
//         <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
//           <Col xs={24} sm={8}>
//             <Card 
//               loading={statsLoading}
//               style={{ backgroundColor: '#ffd700', border: 'none', borderRadius: '8px', textAlign: 'center', height: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} 
//               bodyStyle={{ padding: '20px' }}
//             >
//               <div style={{ fontSize: '36px', fontWeight: 'bold', color: '#333333', marginBottom: '8px' }}>
//                 {dashboardStats.kanbans_in_stock}
//               </div>
//               <div style={{ fontSize: '16px', color: '#333333', fontWeight: '500' }}>Kanbans in Stock</div>
//             </Card>
//           </Col>
//           <Col xs={24} sm={8}>
//             <Card 
//               loading={statsLoading}
//               style={{ backgroundColor: '#52c41a', border: 'none', borderRadius: '8px', textAlign: 'center', height: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} 
//               bodyStyle={{ padding: '20px' }}
//             >
//               <div style={{ fontSize: '36px', fontWeight: 'bold', color: 'white', marginBottom: '8px' }}>
//                 {dashboardStats.kanbans_sent_today}
//               </div>
//               <div style={{ fontSize: '16px', color: 'white', fontWeight: '500' }}>Kanbans Sent Today</div>
//             </Card>
//           </Col>
//           <Col xs={24} sm={8}>
//             <Card 
//               loading={statsLoading}
//               style={{ backgroundColor: '#1e3a8a', border: 'none', borderRadius: '8px', textAlign: 'center', height: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} 
//               bodyStyle={{ padding: '20px' }}
//             >
//               <div style={{ fontSize: '36px', fontWeight: 'bold', color: 'white', marginBottom: '8px' }}>
//                 {dashboardStats.kanbans_received_today}
//               </div>
//               <div style={{ fontSize: '16px', color: 'white', fontWeight: '500' }}>Kanbans Received Today</div>
//             </Card>
//           </Col>
//         </Row>

//         {/* Data Table Section */}
//         <Card style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
//           {/* Table Header */}
//           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '16px' }}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
//               <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#333333' }}>Kanbans In Stock</h3>
//               <Space>
//                 <Button icon={<CopyOutlined />} onClick={() => handleExport('copy')} style={{ backgroundColor: '#f5f5f5', border: '1px solid #d9d9d9' }}>Copy</Button>
//                 <Button icon={<FileExcelOutlined />} onClick={() => handleExport('excel')} style={{ backgroundColor: '#f5f5f5', border: '1px solid #d9d9d9' }}>Excel</Button>
//                 <Button icon={<FilePdfOutlined />} onClick={() => handleExport('pdf')} style={{ backgroundColor: '#f5f5f5', border: '1px solid #d9d9d9' }}>PDF</Button>
//               </Space>
//             </div>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//               <span style={{ fontSize: '14px', color: '#666' }}>Search:</span>
//               <Input placeholder="Search kanbans..." value={searchText} onChange={(e) => setSearchText(e.target.value)} style={{ width: '200px' }} suffix={<SearchOutlined style={{ color: '#999' }} />} />
//             </div>
//           </div>

//           {/* Data Table */}
//           <Table 
//             columns={columns} 
//             dataSource={filteredData} 
//             pagination={{ 
//               pageSize: 10, 
//               showSizeChanger: true, 
//               showQuickJumper: true, 
//               showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items` 
//             }} 
//             loading={tableLoading} 
//             scroll={{ x: 1200 }} 
//             style={{ backgroundColor: 'white' }} 
//           />
//         </Card>
//       </div>
//         </div>
//     );
// };


// export default DashboardPage;

import Dashboard from "../../components/ManageBin/Bin/Dashboard";

const DashboardPage = ({ userData }) => {
  return <Dashboard userData={userData} />;
};

export default DashboardPage;